module.exports = ".form_wizard{width:90%;margin-top:12px}\n"